import { motion } from "framer-motion";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { COMPONENTS, SPACING } from "../../../constants/design/spacing";
import { FundingHistoryTab } from "../../FundingHistoryTab";
import SettlementHistoryTab from "../../SettlementHistoryTab";
import { ReactComponent as FundingLogo } from "../../../assets/svg/dollar.svg";
import { ReactComponent as SettlementLogo } from "../../../assets/svg/settlement.svg";
import { IPage } from "../../shared";
import {
  ContentsWrapper,
  InnerContentsWrapper,
  MobilePageWrapper,
  MobileTabActionsWrapper,
  MobileTabLinkWrapper,
} from "../../style";
import { PageEndpointEnum } from "../../../enums/endpoint";

function MobileHistoricalPage() {
  const location = useLocation();
  const activePage = useMemo(
    () => location.pathname.split(`${PageEndpointEnum.HISTORICAL}/`)[1],
    [location]
  );
  const { t } = useTranslation("app", { keyPrefix: "pages.HistoricalPage" });

  const pages: IPage[] = useMemo(
    () => [
      {
        title: t("settlement_history"),
        path: "/settlement-history",
        redirect: "settlement-history",
        Logo: SettlementLogo,
        element: <SettlementHistoryTab isMobile />,
        isActive: activePage === "settlement-history",
      },
      {
        title: t("funding_history"),
        path: "/funding-history",
        redirect: "funding-history",
        Logo: FundingLogo,
        element: <FundingHistoryTab isMobile />,
        isActive: activePage === "funding-history",
      },
      {
        title: "",
        path: "*",
        redirect: `${PageEndpointEnum.HISTORICAL}/settlement-history`,
        element: (
          <Navigate to={`${PageEndpointEnum.HISTORICAL}/settlement-history`} />
        ),
        isActive: false,
      },
    ],
    [t, activePage]
  );

  return (
    <MobilePageWrapper>
      <MobileTabActionsWrapper>
        <div>
          {pages.map((page, i) => (
            <motion.div
              key={page.title}
              transition={{
                delay: i * 0.1,
                duration: 0.5,
                ease: "easeInOut",
              }}
              initial={{
                transform: "translateY(-8px)",
                opacity: 0,
              }}
              animate={{
                transform: "translateY(0px)",
                opacity: 1,
              }}
              exit={{
                opacity: 0,
              }}
            >
              <MobileTabLinkWrapper
                to={page.redirect}
                $isActive={page.isActive}
              >
                {page.title}
              </MobileTabLinkWrapper>
            </motion.div>
          ))}
        </div>
      </MobileTabActionsWrapper>
      <ContentsWrapper isMobileScreen>
        <InnerContentsWrapper
          isMobileScreen
          style={{
            paddingTop: COMPONENTS.portfolioNavigation,
            paddingLeft: SPACING.three,
            paddingRight: SPACING.three,
          }}
        >
          <Routes>
            {pages.map((page) => (
              <Route key={page.path} path={page.path} element={page.element} />
            ))}
          </Routes>
        </InnerContentsWrapper>
      </ContentsWrapper>
    </MobilePageWrapper>
  );
}

export default MobileHistoricalPage;
